import { useState } from "react";
import { AITutorDualModePanel, type AITutorDualMode } from "./AITutorDualModePanel";
import type { TelegramUser } from "../types";

export interface TaskForChat {
  id: number;
  title: string;
  description?: string;
  domain?: string;
  difficulty?: string;
  tag?: string[];
}

interface AITutorTaskListPanelProps {
  user: TelegramUser | null;
  onClose: () => void;
  embedded?: boolean;
  onMinWidthChange?: (width: number) => void;
  /** Если возвращает true, сообщение не отправляется в чат (обработано родителем, напр. онбординг) */
  onBeforeSendMessage?: (message: string) => boolean;
  /** Каталог задач тренажёра — чат использует его для подборок по запросу (напр. «какие задачи про массивы») */
  tasks?: TaskForChat[];
  /** Применить подборку: отфильтровать список задач по id (вызывается при клике на блок подборки в ответе чата) */
  onApplyTaskSelection?: (taskIds: number[]) => void;
  /** Ключ страницы для вопроса «Как пользоваться [страница]» (tasklist) */
  onboardingPageKey?: string;
  /** Завершённые онбординги — вопрос не показывается, если page_key в списке */
  onboardingCompletedPages?: string[];
  /** По клику на вопрос онбординга — запуск тура */
  onStartOnboarding?: () => void;
  /** Режим панели: чат или roadmap (контролируемый) */
  asideMode?: AITutorDualMode;
  onAsideModeChange?: (mode: AITutorDualMode) => void;
}

export const AITutorTaskListPanel = ({
  user,
  onClose,
  embedded = false,
  onMinWidthChange,
  onBeforeSendMessage,
  tasks = [],
  onApplyTaskSelection,
  onboardingPageKey,
  onboardingCompletedPages,
  onStartOnboarding,
  asideMode: asideModeProp,
  onAsideModeChange: onAsideModeChangeProp,
}: AITutorTaskListPanelProps) => {
  const [internalMode, setInternalMode] = useState<AITutorDualMode>("chat");
  const asideMode = asideModeProp ?? internalMode;
  const onAsideModeChange = onAsideModeChangeProp ?? setInternalMode;

  const chatProps = {
    contextType: "tasklist" as const,
    headerSubtitle: embedded ? "Подбор задач по теме и сложности." : undefined,
    showChatHistoryInEmbedded: embedded,
    onBeforeSendMessage,
    tasksMetadata: tasks.length > 0 ? tasks : undefined,
    onApplyTaskSelection,
    onboardingPageKey,
    onboardingCompletedPages,
    onStartOnboarding,
    enableFeedback: true,
    embedded,
    onMinWidthChange,
  };

  return (
    <AITutorDualModePanel
      user={user}
      onClose={onClose}
      embedded={embedded}
      onMinWidthChange={onMinWidthChange}
      mode={asideMode}
      onModeChange={onAsideModeChange}
      chatProps={chatProps}
    />
  );
};
